enum ProductsActionTypesEnum {
  SAVE_PRODUCTS = 'SAVE_PRODUCTS',
}

export default ProductsActionTypesEnum;
